import { IContact } from '@trii/types/dist/Contacts/contacts';

/**
 * Type guard to check if an object is an IContact
 * @param obj The object to check
 * @returns True if the object is an IContact
 */
export function isContact(obj: any): obj is IContact {
  // Si está marcado explícitamente como negocio, no es un contacto regular
  if (obj?.isBusiness === true) {
    return false;
  }
  
  return (
    obj !== null &&
    typeof obj === 'object' &&
    typeof obj.id === 'string' &&
    typeof obj.spaceId === 'string' &&
    typeof obj.name === 'string' &&
    typeof obj.firstName === 'string' &&
    typeof obj.lastName === 'string' &&
    Array.isArray(obj.phones) &&
    Array.isArray(obj.emails) &&
    'origin' in obj &&
    typeof obj.isSpam === 'boolean' &&
    (!obj.businessId || typeof obj.businessId === 'string')
  );
}
